module.exports = __webpack_public_path__ + "static/ms-icon-144x144-5e7d9f514cbf4374143b90fca0262592.png";